import { AsyncPipe, NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { DynamicFormModel, DynamicFormService, DynamicInputModel, DynamicTextAreaModel } from '@ng-dynamic-forms/core';
import { GlobalMessageService, GlobalMessageType, TranslatePipe } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { CartExtendService } from 'src/app/service/cart/cart-extend.service';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { DynamicFormsComponent } from '../../../../dynamic-forms/dynamic-forms.component';

@Component({
  selector: 'app-edit-cart-modal',
  templateUrl: './edit-cart-modal.component.html',
  styleUrls: ['./edit-cart-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatIcon, DynamicFormsComponent, NgClass, AsyncPipe, TranslatePipe],
})
export class EditCartModalComponent implements OnInit, OnDestroy {
  values: any;
  disabled: boolean;
  cartId: string;

  formGroup: FormGroup;
  formModel: DynamicFormModel;
  saveCartDetailsFormModelSubscription$: Subscription;
  saveCartDetailsFormGroupSubscription$: Subscription;

  constructor(
    protected modalService: StandardModalService,
    private cartService: CartExtendService,
    private formService: DynamicFormService,
    private messageService: GlobalMessageService,
    private componentService: ComponentService,
    private languageService: ShimanoLanguageService
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.values = res.values;
        this.disabled = res.disabled;
        this.cartId = res.cartId;
      });
  }

  ngOnInit() {
    this.saveCartDetailsFormGroupSubscription$ = this.componentService.dynamicFormGroup$.subscribe(
      (savedCartDetailsFormGroup) => {
        this.updateFormGroup(savedCartDetailsFormGroup);
      }
    );

    this.saveCartDetailsFormModelSubscription$ = this.componentService.dynamicFormModel$.subscribe(
      (savedCartDetailsFormModel) => {
        this.updateFormModel(savedCartDetailsFormModel);
      }
    );
  }

  updateCartDetails(form: any) {
    if (typeof form !== 'undefined') {
      const SAVE_CART_MODAL_FORM = {
        name: form.value.saveCartName,
        description: form.value.saveCartDescription,
      };
      this.cartService
        .saveCart(SAVE_CART_MODAL_FORM, this.cartId)
        .pipe(take(1))
        .subscribe((data: any) => {
          this.componentService.setSavedCartDetails(true);
          this.closeModal(form.value);
          this.showGlobalMessage(
            'cart.savedCart.message.editCartDetailsSuccess',
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
        });
    } else {
      this.closeModal({ saveCartName: this.values[0].value, saveCartDescription: this.values[1].value });
      this.showGlobalMessage('cart.savedCart.message.editCartDetailsSuccess', GlobalMessageType.MSG_TYPE_CONFIRMATION);
    }
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }

  updateFormGroup(form: any): void {
    this.formGroup = form;
    form.valueChanges.subscribe((data: any) => {
      this.disabled = !this.formGroup.valid;
      if (
        (data.saveCartName &&
          data.saveCartName !== this.values[0].value &&
          data.saveCartDescription) ||
        (data.saveCartDescription &&
          data.saveCartDescription !== this.values[1].value &&
          data.saveCartName)
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    });
  }
  updateFormModel(form: any): void {
    this.formModel = form;
    const saveCartTitleInput = this.formService.findModelById<DynamicInputModel>('saveCartName', this.formModel);
    const saveCartDescriptionInput = this.formService.findModelById<DynamicTextAreaModel>(
      'saveCartDescription',
      this.formModel
    );

    if (saveCartTitleInput !== null) {
      saveCartTitleInput.maxLength = 255;
      this.formService.detectChanges();
    }

    if (saveCartDescriptionInput !== null) {
      saveCartDescriptionInput.maxLength = 255;
      this.formService.detectChanges();
    }
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  ngOnDestroy(): void {
    if (this.saveCartDetailsFormModelSubscription$) {
      this.saveCartDetailsFormModelSubscription$.unsubscribe();
    }
    if (this.saveCartDetailsFormGroupSubscription$) {
      this.saveCartDetailsFormGroupSubscription$.unsubscribe();
    }
  }
}
